<template>
    <div>
        <div>
            <el-row :gutter="10">
                <el-col :xm="24" :md="12" :lg="14" style="margin-bottom:30px;">
                    <div class="biaoqian">在线视频制作</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <div style="font-size: 14px;">
                            <qhyupload ref="qhyupload" from="qc"></qhyupload>
                        </div>
                        <div style="margin-top:25px;">
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div style="display: flex;align-items:center">
                                    <div style="margin:10px 0px;font-weight: 600;color: #666;">预设方案</div>
                                    <div style="font-size: 12px;margin-left: 5px;color: #828282;cursor: pointer;"
                                        :style="{ 'color': yushe_edit_id != null ? '#ff1133' : '#828282' }"
                                        @click="yushe_edit_id = yushe_edit_id == null ? true : null">
                                        {{ yushe_edit_id == null ? '编辑' : '取消编辑' }}
                                    </div>
                                </div>
                                <div style="color: #666;display: flex;align-items: center;" @click="yushe_save()">
                                    <i class="el-icon-document-add"></i>
                                    <div style="font-size: 13px;color: #666;margin-left: 3px;">
                                        保存选择
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                                <div v-for="(item, index) in yushe" :key="index"
                                    style="background-color: #eaeaea;border-radius: 0.5vh;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;font-size: 0.8rem;min-width: 4rem;"
                                    @click="yushe_index = index; ms_check = item.list; yushe_edit_id = yushe_edit_id == true ? index : yushe_edit_id;"
                                    :style="{ backgroundColor: (index == yushe_index ? '#484add' : '#eaeaea'), color: (index == yushe_index ? '#fff' : '#5a5a5a') }">
                                    <div class="no-select">{{ item.name }}</div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top:25px;">
                            <div style="margin:10px 0px;font-weight: 600;color: #666;">二创特效</div>
                            <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                                <div v-for="(ms_one, index) in (ms_list.data || [])"
                                    :key="ms_one.value != null ? ms_one.value : index"
                                    style="background-color: #eaeaea;border-radius: 0.5vh;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;font-size: 0.8rem;min-width: 4rem;"
                                    @click="ms_check_fc(ms_mode_key(ms_one))"
                                    :style="{ backgroundColor: (ms_check.includes(ms_mode_key(ms_one)) ? '#484add' : '#eaeaea'), color: (ms_check.includes(ms_mode_key(ms_one)) ? '#fff' : '#5a5a5a') }">
                                    <div class="no-select">{{ ms_one.name }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- <div style="margin-top:25px;">
                            <div style="margin:10px 0px;font-weight: 600;color: #666;">附加选择</div>
                            <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                                <div v-for="(item, index) in (ms_list.other || [])" :key="index"
                                    style="background-color: #eaeaea;border-radius: 0.5vh;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;font-size: 0.8rem;min-width: 4rem;"
                                    @click="ms_check_fc(item.value)"
                                    :style="{ backgroundColor: (ms_check.includes(item.value) ? '#484add' : '#eaeaea'), color: (ms_check.includes(item.value) ? '#fff' : '#5a5a5a') }">
                                    <div class="no-select">{{ item.name }}</div>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div>
                            <div class="biaoqian">裂变数量</div>
                            <div style="display: flex;align-items: center;">
                                <div style="font-size: 14px;margin-right: 10px;">
                                    单个视频制作数量:
                                </div>
                                <el-input-number v-model="xgcs" :min="1" :max="100" label="数量"
                                    size="mini"></el-input-number>
                            </div>
                        </div> -->
                        <div style="margin-top:30px;">
                            <el-button @click="ks()" style="width:100%;background-color: #484add;border-color: #484add;"
                                type="success" :loading="uploading">立即制作</el-button>
                        </div>
                    </el-card>
                </el-col>
                <el-col :xm="24" :md="12" :lg="10">
                    <div class="biaoqian">制作记录</div>
                    <el-card class="box-card" style="border-radius:10px;" shadow="never">
                        <div style="font-size: 14px;">
                            <!-- <div style="margin:10px 0px;">制作记录</div> -->
                            <Record ref="record"></Record>
                        </div>

                    </el-card>
                </el-col>
            </el-row>
        </div>

        <el-dialog title="编辑方案" :visible="typeof yushe_edit_id === 'number'" custom-class="newdialog">
            <div v-if="typeof yushe_edit_id === 'number'" style="display: flex;align-items: center;">
                名称：<el-input v-model="yushe[yushe_edit_id].name" placeholder="请输入名称" style="width: 80%;"
                    size="medium"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="yushe_edit('删除', yushe_edit_id)" size="medium" type="danger">删
                    除</el-button>
                <el-button @click="yushe_edit('重命名', yushe_edit_id)" size="medium" type="primary">确 定</el-button>
                <el-button @click="yushe_edit_id = true" size="medium">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Record from "./Record.vue";
import Balance from './Balance.vue';
import Dingzhi from "./Dingzhi.vue";


export default {
    name: '',
    components: {
        Record,
        Balance,
        Dingzhi
    },
    // 定义属性
    data() {
        return {
            allurl: '',
            url_num: 30,
            ms_list: [],
            ms_other: [],
            ms_other_one: [],
            videoFileList: [],
            spnum: 0,
            make_type: '链接上传',
            video_num: 0,
            ksing: false,
            dingzhi_show: false,
            xgcs: 1,
            upload_fq: [],

            uploading: false,
            ms_check: [],
            yushe: [],
            yushe_index: null,
            yushe_edit_id: null,
            yushe_edit_name_index: null,
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ms_mode_key(row) {
            if (!row) return ''
            return row.value != null ? row.value : row.url
        },
        ms_main_group_keys() {
            const data = this.ms_list.data || []
            return data.map(i => this.ms_mode_key(i)).filter(k => k !== '' && k != null)
        },
        ms_check_fc(key) {
            const tempSet = new Set(this.ms_check);
            tempSet[tempSet.has(key) ? 'delete' : 'add'](key);
            this.ms_check = [...tempSet];
        },
        yushe_save() {
            console.log(this.ms_check)
            console.log(this.yushe)
            this.yushe.push({ name: '方案' + (this.yushe.length + 1), list: [...this.ms_check] })
            try {
                localStorage.setItem('yushe', JSON.stringify(this.yushe))
            } catch (e) { /* ignore */ }
            this.yushe_update()
        },
        yushe_edit(type, id) {
            var that = this
            console.log(type, id)
            if (type == '删除') {
                this.$confirm('删除后将不可恢复', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.yushe.splice(id, 1)
                    try {
                        localStorage.setItem('yushe', JSON.stringify(that.yushe))
                    } catch (e) { /* ignore */ }
                    that.yushe_update()
                    that.yushe_edit_id = null
                }).catch(() => {

                });
            }
            if (type == '重命名') {
                try {
                    localStorage.setItem('yushe', JSON.stringify(that.yushe))
                } catch (e) { /* ignore */ }
                that.yushe_update()
                that.yushe_edit_id = null
            }
        },
        yushe_update(item = this.yushe) {
            const loading = this.$loading(this.$loadinginfo);
            var data = { data: JSON.stringify(item) }
            this.$ajax.post('/qhy/user/ms_yushe', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                this.$msg.success(res.data.msg)
                loading.close();
            })
        },
        yushe_get() {
            try {
                const raw = localStorage.getItem('yushe')
                if (!raw) return
                const yusheget = JSON.parse(raw)
                if (!Array.isArray(yusheget)) return
                const uniqueKeys = new Set(this.yushe.map(obj => `${obj.name}`))
                yusheget.forEach(obj => {
                    const key = `${obj.name}`
                    if (!uniqueKeys.has(key)) {
                        this.yushe.push(obj)
                        uniqueKeys.add(key)
                    }
                })
            } catch (e) { /* ignore */ }
        },
        get_ms() {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('/qhy/user/ms_v2', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.ms_list = res.data
                    const rows = this.ms_list.data || []
                    if (rows.length) {
                        const first = rows[0]
                        this.ms_check = [first.value != null ? first.value : first.url]
                    } else {
                        this.ms_check = []
                    }
                    this.ms_other = res.data.other || []
                    this.yushe = Array.isArray(res.data.yushe) ? res.data.yushe : []
                    this.yushe_get()
                    try {
                        var ui = window.sessionStorage.getItem('userinfo')
                        if (ui) {
                            ui = JSON.parse(ui)
                            if (ui.fwq) this.url_num = 200
                        }
                    } catch (error) {

                    }
                } else {
                    this.$msg.error(res.data.msg || '异常')
                }
                loading.close();
            })
        },
        ks() {
            var ms = this.ms_check.join('')
            if (!ms) {
                return this.$msg.error('请选择模式')
            }
            console.log(ms)
            var urls = this.$refs.qhyupload.get_urls(1)
            if (urls.status == 100) {
                return this.$msg.error(urls.msg)
            }
            urls = JSON.stringify(urls)
            var data = {
                'url': urls,
                'spdz': urls,
                'ms': ms,
                'xgcs': this.xgcs,
                'type': 'qcai'
            }
            // console.log(JSON.stringify(data))
            // return
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('/qhy/user/makevieo', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    // console.log(index)
                    // this.$msg.success(res.data.msg)
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        customClass: 'newdialog',
                        callback: action => {
                            const balanceComp = this.$parent.$parent.$parent.$parent
                            if (balanceComp && typeof balanceComp.get_balance === 'function') balanceComp.get_balance()
                            this.allurl = ''
                            this.$refs.qhyupload.clear_url()
                        }
                    });
                    // this.$refs.Balance.get_user()
                } else {
                    this.$msg.error(res.data.msg)
                }
            }).finally(() => {
                this.uploading = false
                loading.close();
            })
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

        this.get_ms()
        this.common.ismobile(this)

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.upload2 .el-upload {
    width: 100%;
}

.upload2 .el-upload-dragger {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Qcai.vue



// WEBPACK FOOTER //
// src/components/User/Qcai.vue